import { safeLocalStorage } from "./safeLocalStorage.ts";

export const MOBILE_IA_V3_FLAG = "mobileIA_v3";

const disabledValues = new Set(["0", "disabled", "false", "off"]);

export const resolveMobileIAV3FlagValue = (
	value: string | null | undefined,
) => {
	if (value === null || value === undefined || value.trim() === "") {
		return true;
	}

	return !disabledValues.has(value.trim().toLowerCase());
};

export const isMobileIAV3Enabled = () => {
	if (typeof window === "undefined") {
		return true;
	}

	return resolveMobileIAV3FlagValue(
		safeLocalStorage.getItem(MOBILE_IA_V3_FLAG),
	);
};
